import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  column-gap: 6px;
  margin-bottom: 96px;

  @media screen and (max-width: 1023px) {
    flex-direction: column;
    margin-bottom: 0;
  }
`;

export const Group = styled.div`
  width: 100%;

  img {
    width: 100%;
    object-fit: contain;
    margin-bottom: 32px;
  }

  @media screen and (max-width: 1023px) {
    margin-bottom: 64px;

    img {
      margin-bottom: 24px;
    }
  }
`;

export const Legend = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 28px;
  color: #000;

  @media screen and (max-width: 500px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Credits = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 28px;

  article {
    width: 100%;
    max-width: 444px;
  }

  h2 {
    width: 100%;
    font-family: ${fonts.BentonSansWideBold};
    font-size: 14px;
    line-height: 22px;
    text-transform: uppercase;
    padding-bottom: 16px;
    border-bottom: 1px solid #000;
    margin-bottom: 40px;
  }

  @media screen and (max-width: 500px) {
    line-height: 26px;
    padding: 0 40px 80px 40px;
    align-items: flex-start;
  }
`;
